import {
  SHIPMENT_ADD_SUCCESS,
  SHIPMENT_ADD_FAIL,
  SHIPMENT_REMOVE,
} from "./types";

export const shipmentAdd = (data) => async (dispatch) => {
  try {
    console.log(data);
    dispatch({
      type: SHIPMENT_ADD_SUCCESS,
      payload: data,
    });
    return data;
  } catch (err) {
    console.log(err);
    dispatch({
      type: SHIPMENT_ADD_FAIL,
    });
  }
};

export const shipmentRemove = (data) => async (dispatch) => {
  try {
    dispatch({
      type: SHIPMENT_REMOVE,
      payload: data,
    });
    return data;
  } catch (err) {
    dispatch({
      type: SHIPMENT_ADD_FAIL,
    });
  }
};

export const getShipment = () => async (dispatch) => {
  try {
    const res = localStorage.getItem("shipment");
    return JSON.parse(res);
  } catch (err) {
    return "shipment empty";
  }
};
